import React, { useState } from 'react';
import "./WebLayout.css";
import Footer from '../../Footer';
import { useMatch } from "react-router-dom";

const WebLayout = ({ children }) => {
    const locationAdmin = useMatch("admin/*") ? true : false;

    return (
    <>
        {children}
        {!locationAdmin &&
        <Footer />
        }

    </>

    );
};

export default WebLayout;